import { render, staticRenderFns } from "./ActivityLogsForm.vue?vue&type=template&id=ecb87f7a&"
import script from "./ActivityLogsForm.vue?vue&type=script&lang=js&"
export * from "./ActivityLogsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports